module.exports = __webpack_public_path__ + "static/media/Illus-Location@2x.5eea8f36.png";